
function check_roles(...expected)
{
	const roles = window.Grape.currentSession.roles;
	if (roles === undefined || roles === null) return false;

	for (let i = 0; i < expected.length; i++)
	{
		if (roles.indexOf(expected[i]) === -1) return false;
	}

	return true;
}

export async function checkAccessRights(featureName)
{
	if (isLoggedInUser_Employee())
	{
		let features;
		try {
			let res = await Grape.fetches.getJSON('/settings/get_user_features_access', {});
			if (res != null)
				features = res.result;

		} catch (e) {
			features = [];
		}

		if (features && features.length > 0)
		{
			let match = features.find(f => f.feature === featureName);
			if (match)
				return match.has_access;
			else
				return false;
		}
		else return false;
	}
	else
		return false;
}

//* *returns true if employee doesnt have any other rights than employee**//
export function isLoggedInUser_OnlyEmployee() {
	return check_roles('employee') && !check_roles('manager') && !check_roles('admin');
}

export function isLoggedInUser_Employee() {
	return check_roles('employee');
}

export function isLoggedInUser_Developer() {
	return check_roles('developer');
}

export function isLoggedInUser_Manager() {
	return check_roles('manager');
}

export function isLoggedInUser_Admin() {
	return check_roles('admin');
}

export function isLoggedInUser_AdminOrManager() {
	return check_roles('admin') || check_roles('manager');
}

export function isLoggedInUser_AssistantManager() {
	return check_roles('assistant_manager');
}

export function isLoggedInUser_Unverified() {
	return check_roles('unverified_user');
}

export function isLoggedInUser_Accountant() {
	return check_roles('accountant');
}

export function isLoggedInUser_ExternalManager() {
	return check_roles('external_manager');
}
